var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2.406c4.148 0 7.594 3.41 7.594 7.594A7.585 7.585 0 0110 17.594 7.562 7.562 0 012.406 10 7.584 7.584 0 0110 2.406zm0-1.125C5.184 1.281 1.281 5.22 1.281 10A8.717 8.717 0 0010 18.719c4.781 0 8.719-3.903 8.719-8.719 0-4.781-3.938-8.719-8.719-8.719zM8.734 13.375a.427.427 0 00-.421.422v.281c0 .246.175.422.421.422h2.532a.427.427 0 00.421-.422v-.281a.454.454 0 00-.421-.422h-.422V8.453a.454.454 0 00-.422-.422H8.734a.427.427 0 00-.421.422v.281c0 .246.175.422.421.422h.422v4.219h-.422zM10 4.937c-.633 0-1.125.528-1.125 1.125A1.11 1.11 0 0010 7.188c.598 0 1.125-.492 1.125-1.125 0-.597-.527-1.125-1.125-1.125z",
    fill: "#1A65BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.e1a7743d54e091ea780dc068a9a6858e.svg";
export { ForwardRef as ReactComponent };